import { generateClient } from 'aws-amplify/api';
import { searchScopes } from "../common/graphql/queries";
import FormSelectInput from "./FormSelectInput";

const client = generateClient();

let runningPromise = {};
const FormSelectScopeOfWork = (props) => {
    const loadOptions = async (input) => {
        try {
            if (runningPromise[props.name]) client.cancel(runningPromise[props.name], "cancelled");
            runningPromise[props.name] = client.graphql({
                query: searchScopes,
                variables: {
                    filter: {
                        active: { eq: true },
                        locationId: { eq: props.locationId },
                        name: { wildcard: `*${input}*` },
                        or: [
                            { account: { eq: "COS - Labour" } },
                            { account: { eq: "COS - Shop Labour" } },
                            { account: { eq: "Training & Safety Expense" } },
                        ]
                    },
                    sort: { direction: "asc", field: "name" },
                    limit: 1000,
                },
            })

            const { data: { searchScopes: { items } } } = await runningPromise[props.name];

            return items.map(cx => ({ value: cx.id, label: cx.name }))
        } catch (ex) {
            return []
        }
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} placeholder="Select a scope of work" />
    )
}

export default FormSelectScopeOfWork;